import React from "react";
import { Box, CircularProgress, Alert } from "@mui/material";

interface LoadingStateProps {
  isLoading: boolean;
  error: unknown;
  hasData: boolean;
  children: React.ReactNode;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  isLoading,
  error,
  hasData,
  children,
}) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        Failed to load monitoring data. Please try again later.
      </Alert>
    );
  }

  if (!hasData) {
    return (
      <Alert severity="info" sx={{ m: 3 }}>
        No monitoring data available.
      </Alert>
    );
  }

  return children;
};

export default LoadingState;
